function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');
var WINDOW = core.GLOBAL_OBJ;
var INTEGRATION_NAME = 'ReportingObserver';
var SETUP_CLIENTS = new WeakMap();
var _reportingObserverIntegration = function _reportingObserverIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var types = options.types || ['crash', 'deprecation', 'intervention'];

  /** Handler for the reporting observer. */
  function handler(reports) {
    if (!SETUP_CLIENTS.has(core.getClient())) {
      return;
    }
    var _iterator = _createForOfIteratorHelper(reports),
      _step;
    try {
      var _loop = function _loop() {
        var report = _step.value;
        core.withScope(function (scope) {
          scope.setExtra('url', report.url);
          var label = "ReportingObserver [".concat(report.type, "]");
          var details = 'No details available';
          if (report.body) {
            // Object.keys doesn't work on ReportBody, as all properties are inherited
            var plainBody = {};

            // eslint-disable-next-line guard-for-in
            for (var prop in report.body) {
              plainBody[prop] = report.body[prop];
            }
            scope.setExtra('body', plainBody);
            if (report.type === 'crash') {
              var body = report.body;
              // A fancy way to create a message out of crashId OR reason OR both OR fallback
              details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
            } else {
              var _body = report.body;
              details = _body.message || details;
            }
          }
          core.captureMessage("".concat(label, ": ").concat(details));
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    name: INTEGRATION_NAME,
    setupOnce: function setupOnce() {
      if (!core.supportsReportingObserver()) {
        return;
      }
      var observer = new WINDOW.ReportingObserver(handler, {
        buffered: true,
        types: types
      });
      observer.observe();
    },
    setup: function setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
};

/**
 * Reporting API integration - https://w3c.github.io/reporting/
 */
var reportingObserverIntegration = core.defineIntegration(_reportingObserverIntegration);
exports.reportingObserverIntegration = reportingObserverIntegration;